export default {
    url: '/edit/:id',
    template: '<forms-settings-pool-edit question-pool="vm.questionPool"></forms-settings-pool-edit>',
    resolve: {
        questionPool: (QuestionPoolResource, $stateParams) => QuestionPoolResource.get({ id: $stateParams.id, expand: 'activeI18n,poolI18ns' }).$promise
    },
    controller (questionPool) {
        this.questionPool = questionPool;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/forms/settings/pool/edit/index.js